

export const AlertMessage = {
    certificateGenerationInProgress: "A geração dos certificados do treinamento está em andamento.",
    userNotLinkedToTraining: "O usuário não está vinculado a este treinamento.",
    /* DEFAULT MESSAGES */
    userWithoutCpf: "Não foi possivel gerar os certificados, existem usuários sem cpf cadastrados.",
    invalidDate: "Data inicial ou final inválida",
    notExpected: "Conteúdo inesperado recebido",
    generalEmpty: "Há campos obrigatórios não preenchidos",
    noUsersToGenerateCertificates: "Não há usuários vinculados ao treinamento para gerar certificados.",
    notPossibleSave: "Não foi possível salvar",
    namedResourceNameExists: "Já existe um cadastro com esse mesmo nome.",
    inconsistentTime: "O horário inicial não pode ser maior que o horário final",
    notPossibleSearch: "Não foi possível realizar a pesquisa.",
    notPossibleUpdate: "Não foi possível atualizar",
    notPossibleDelete: "Não foi possível excluir",
    charactersExceeded: "Limite de caracteres excedidos",
    imageInvalid: "Tamanho máximo de arquivo excedido. Limite: 10MB",
    archiveInvalid: "Essa extensão de arquivo não pode ser salva",

    /* Resales */
    resellerHasProjectsAndUsers: "A revenda possui projetos e usuários vinculados.",
    resellerHasProjects: "A revenda possui projetos vinculados.",
    resellerHasUsers: "A revenda possui usuários vinculados.",

    /* Users */
    invalidPassword: "A senha precisa ter no mínimo 8 caracteres, com até uma letra maiúscula, uma minúscula, um número e um símbolo.",
    loginExists: "Já existe um usuário com esse mesmo login.",
    nameExists: "Já existe um usuário com esse mesmo nome para esse projeto.",
    invalidConfirmationPassword: "O valor da nova senha e da confirmação precisa ser igual.",
    invalidOldPassword: "Senha incorreta.",
    userProjectCannotCombined: "A permissão 'Cadastro de atendimentos e chamados (somente para clientes)' não pode estar em conjunto com outras permissões.",
    duplicateCpf: "Já existe um usuário com esse mesmo cpf.",

    cpfAlreadyActive: "CPF já cadastrado em outro usuário.",

    /* Projects */
    projectAlreadyExist: "Já existe um projeto com o mesmo nome.",
    licencesEmptyField: "Todos os campos de licenças são obrigatórios.",
    sshEmptyField: "O campo Nome, IP e Tipo de conexão do Acesso SSH aos servidores são campos obrigatórios.",
    projectHasUsers: "O projeto possui usuários vinculado",
    projectHasSoftwareAttendance: "O projeto possui atendimentos vinculado",
    projectHasHardwareAttendance: "O projeto possui chamados vinculado",
    projectHasProduct: "O projeto possui produtos vinculado",
    requireJumpServerForAcrossJumpServer: "Para adicionar um SSH do tipo 'Via Jump Server', é necessário incluir um SSH do tipo 'Jump Server'.",

    /* Licenses */
    notPossibleToGenerateLicense: "Não foi possível gerar a licença",
    hashEmpty: "O campo Hardware ID é obrigatório.",
    emptyInfo: "Nenhuma informação de licença cadastrada no projeto. Verificar.",
    activationDateIsNull: "É necessário informar a data de ativação no cadastro de Projetos (Cidade) antes de gerar a licença.",
    invalidExpirationDate: "Data de expiração da licença inválida.",

    /* Ssh */
    invalidSsh: "Projeto não possui configuração para acesso.",

    /* Hardware Attendances */
    hardwareAttendanceHasPend: "O chamado possui pendência não solucionada.",
    date_initialIsRequired: "O campo Abertura é obrigatório.",
    project_idIsRequired: "O campo Projeto é obrigatório.",
    problemIsRequired: "O campo Requisição é obrigatório.",
    requester_idIsRequired: "O campo Solicitante é obrigatório.",
    hardwareAttendanceHasOrders: "O chamado possui ordem de serviço vinculada.",


    /* Software Attendances */
    titleIsRequired: "O campo Título é obrigatório.",
    dtEndBeforeStart: "d/h de encerramento inferior que d/h de abertura",
    dtIntBeforeNow: "d/h abertura superior que d/h atual",

    /* Order */
    solutionsEmptyField: "Todos os campos de Soluções são obrigatórios.",

    /* Login */
    loginBlockCaptcha: "Acesso bloqueado pelo captcha.",
    loginNotAuthorized: "Não foi possível fazer o login.",
    accessNotAllowed: "Acesso via internet não permitido.",
    loginTooManyAttempts: "Muitas tentativas de login. Aguarde um minuto e tente novamente.",

    /* Product */
    productHasHardwareAttendance: "O produto possui chamados vinculado",

    attendanceExists: "Já há um atendimento registrado com as mesmas informações.",

    /* Request */
    sendEmailError: "Não foi possível enviar o e-mail.",
    userWithoutEmail: "Não foi possível enviar o e-mail, usuário sem e-mail cadastrado.",
    duplicateRelation: "Relação já adicionada.",
    notExistRequest: "Não existe nenhuma solicitação com esse id",

    /* Integration */
    notExistIntegration: "Não existe nenhuma integração com esse id",
    duplicateIntegration: "Integração já adicionada.",

    /* Phone */
    phoneAlreadyExist: "O número de telefone está cadastrado em outro usuário/cliente",

    /* Activity */
    existsDayActivity: "Já existe uma atividade cadastrada com essa data.",
    moreThan30Days: "O período máximo de pesquisa é de 30 dias.",
    fillSomeField: "É necessário preencher pelo menos um campo."
}
